import React, { Component } from 'react'
import project from '../../images/project-img3.png'
import Arrow3Svg from '../icons/Arrow3Svg'
import { Link } from 'react-router-dom'
import image from '../../images/projectscardimage.jpg'
import RightSvg from '../icons/RightSvg'


export class Card4 extends Component {
    render() {
        return (
            <div>
                <div className='rounded-[8px]  h-[250px] max-[390px]:h-[180px]'>
                    <img src={this.props.img} className='rounded-[8px] h-[330px] max-[390px]:h-[260px]' />
                </div>

                <div className='m-[0_40px] max-[400px]:m-[0_15px]'>
                    <div className='relative z-10 bg-[#fff] top-[48px] p-[8px] rounded-[8px] flex justify-between items-center gap-[4px] max-[440px]:gap-[7px]'>
                        <h5 className='font-[700] text-[#2e2f46] text-[28px] max-[1001px]:text-[24px] max-[850px]:text-[22px] max-[650px]:text-[20px] max-[440px]:text-[18px]'>{this.props.title}</h5>

                        <Link to={this.props.path} target='__blank' className='bg-[#78cbde] p-[6px] rounded-[50px]'>
                            <RightSvg
                                width="22"
                                height="22"
                                fill="#fff"
                            />

                        </Link>

                    </div>

                    {/* <div className='flex justify-end'>
                        <button className=''>
                            <RightSvg
                                
                            />
                        </button>
                    </div> */}
                </div>

            </div>
        )
    }
}

export default Card4